import React, { useEffect, useState } from "react";
import { ChevronDown, ChevronUp, DateIcon } from "../../../../asset";
import { DatePicker, Input, Radio, Select, Space } from "antd";
import dayjs from "dayjs";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import SecondaryButton from "../../../../component/button/SecondaryButton";
import { onChanged, validateSubmit } from "../../../../util/Util";
import { useDispatch, useSelector } from "react-redux";
import { validDepot } from "../validation";
import moment from "moment";
import {
  dropdownCustom,
  LoadingOption,
  selectOption,
} from "../../../../component/select/SelectOption";
import SelectSearch from "../../../../component/input/SelectSearch";

import * as UserServices from "../../../../service/admin/User/UserService";
import { dropdownPersonTitle } from "../../../../service/RegionalServices";
import axios from "axios";
import { GROLOG_URL } from "../../../../constant/apiConstant";

export default function PICForm({
  from,
  t,
  style,
  picList,
  setPicList,
  index,
  data,
  id,
  deletedPicList,
  setDeletedPicList,
  checkHasEmpty,
}) {
  const dispatch = useDispatch();
  const _ = require("lodash");
  const { token } = useSelector((state) => state.auth);

  const [isOpen, setIsOpen] = useState(false);
  const [added, setAdded] = useState(false);
  const [form, setForm] = useState({});
  const [error, setError] = useState();

  const [listCountry, setListCountry] = useState([]);
  const [listProvince, setListProvince] = useState([]);
  const [listDistrict, setListDistrict] = useState([]);
  const [listSubDistrict, setListSubDistrict] = useState([]);
  const [listUrbanVillage, setListUrbanVillage] = useState([]);
  const [listPostalCode, setListPostalCode] = useState([]);
  const [listTitle, setListTitle] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageCountry, setPageCountry] = useState(1);
  const [limitCountry, setLimitCountry] = useState(10);
  const [filter, setFilter] = useState("");
  const [pageProvince, setPageProvince] = useState(1);
  const [limitProvince, setLimitProvince] = useState(10);
  const [filterProvince, setFilterProvince] = useState("");
  const [pageDistrict, setPageDistrict] = useState(1);
  const [limitDistrict, setLimitDistrict] = useState(10);
  const [filterDistrict, setFilterDistrict] = useState("");
  const [pageSubdistrict, setPageSubdistrict] = useState(1);
  const [limitSubdistrict, setLimitSubdistrict] = useState(10);
  const [filterSubdistrict, setFilterSubdistrict] = useState("");
  const [pageUrbanvillage, setPageUrbanvillage] = useState(1);
  const [limitUrbanvillage, setLimitUrbanvillage] = useState(10);
  const [filterUrbanvillage, setFilterUrbanvillage] = useState("");
  const [pagePostalCode, setPagePostalCode] = useState(1);
  const [limitPostalCode, setLimitPostalCode] = useState(10);
  const [filterPostalCode, setFilterPostalCode] = useState("");

  const [regionalData, setRegionalData] = useState({
    country_pic: data?.country_pic_id,
    province_pic: data?.province_pic_id,
    district_pic: data?.district_pic_id,
    sub_district_pic: data?.sub_district_pic_id,
    urban_village_pic: data?.urban_village_pic_id,
    postal_code_pic: data?.postal_code_pic_id,
  });

  useEffect(() => {
    if (typeof id === "number") {
      setAdded(true);
    }

    if (from === "add") {
      getListCountry(1, 100);
      getPersonTitle(token, 1, 500);
    } else {
      getListCountry(1, 100);
      getListProvince(data.country_pic_id, 1, 100, "");
      getListDistrict(
        data.country_pic_id,
        data.province_pic_id,
        1,
        100,
        "");
      getListSubDistrict(
        data.country_pic_id,
        data.district_pic_id,
        1,
        500,
        ""
      );
      getListUrbanVillage(
        data.country_pic_id,
        data.sub_district_pic_id,
        1,
        100,
        "");
      getListPostalCode(
        data.urban_village_pic_id,
        1,
        100,
        "");
      getPersonTitle(token, 1, 500);
      checkValue();
    }
    setForm({
      position_pic: data.position_pic,
      title_pic: data.title_pic_id ? data.title_pic_id : data.title_pic,
      first_name_pic: data.first_name_pic,
      last_name_pic: data.last_name_pic,
      gender_pic: data.gender_pic,
      birth_place_pic: data.birth_place_pic,
      birth_date_pic: data.birth_date_pic,
      phone_number_pic: data.phone_number_pic?.replace("+62-", ""),
      email_pic: data.email_pic,
      nik_pic: data.nik_pic,
      npwp_pic: data.npwp_pic,
      country_pic: data.country_pic_id ? data.country_pic_id : data.country_pic,
      province_pic: data.province_pic_id
        ? data.province_pic_id
        : data.province_pic,
      district_pic: data.district_pic_id
        ? data.district_pic_id
        : data.district_pic,
      sub_district_pic: data.sub_district_pic_id
        ? data.sub_district_pic_id
        : data.sub_district_pic,
      urban_village_pic: data.urban_village_pic_id
        ? data.urban_village_pic_id
        : data.urban_village_pic,
      address_pic: data.address_pic,
      neighborhood_pic: data.neighborhood_pic,
      hamlet_pic: data.hamlet_pic,
      postal_code_pic: data.postal_code_pic_id
        ? data.postal_code_pic_id
        : data.postal_code_pic,
    });
  }, [picList]);

  const getPersonTitle = async (token, page, limit) => {
    const params = {
      page,
      limit,
    };
    const res = await dropdownPersonTitle(token, params);
    if (res?.ok && res.list.length > 0) {
      const { list } = res;
      setListTitle(
        list.map((item) => ({
          value: item.id,
          label: item.title,
        }))
      );
    }
  };
  const doGets = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = GROLOG_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  // const isZero = [];
  const getListCountry = async (page, limit, filter) => {
    const currentCountry = [...listCountry];
    let countrys = await doGets(
      `/country?page=${page}&limit=${limit}${filter && `&filter=name lk ${filter}`
      }`,
      token
    );

    let option = [];
    let list = countrys?.data?.payload?.data;

    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      setListCountry(selectOption(currentCountry, option, "value"));
      setLoading(false);
      // this.setState({
      //   listUser: selectOption(currentUser, option, "value"),
      //   initiateUser: initiate,
      //   loading: false,
      // });
    } else {
      setLoading(false);
      // this.setState({ loading: false, lastPage: true });
    }
  };

  const onScrollCountry = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);

      setPageCountry(pageCountry + 1);
      target.scrollTo(0, target.scrollHeight);
      getListCountry(pageCountry, limitCountry);
      // setTimeout(() => {
      //   getListCountry(pageCountry,limitCountry)
      // }, 256);
    }
  };

  const onChangeCountry = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListCountry([]);
      setPageCountry(resetPage);
      // this.setState(
      setTimeout(() => {
        getListCountry(pageCountry, limitCountry, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListCountry([]);
      setFilter(resetFilter);
      setPageCountry(resetPage);
      getListCountry(pageCountry, limitCountry, filter);
    }
  };
  const onScrollProvince = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageProvince(pageProvince + 1);
      target.scrollTo(0, target.scrollHeight);
      getListProvince(form?.country_pic, pageProvince, limitProvince, "");
      // setTimeout(() => {
      //   getListProvince(pageProvince,limitProvince)
      // }, 256);
    }
  };

  const onChangeProvince = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListProvince([]);
      setPageProvince(resetPage);
      // this.setState(
      setTimeout(() => {
        getListProvince(form?.country_pic, pageProvince, limitProvince, filter);
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListProvince([]);
      setFilter(resetFilter);
      setPageProvince(resetPage);
      getListProvince(form?.country_pic, pageProvince, limitProvince, filter);
    }
  };

  const onScrollDistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageDistrict(pageDistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListDistrict(
        form?.country_pic,
        form?.province_pic,
        pageDistrict,
        limitDistrict,
        ""
      );
      // setTimeout(() => {
      //   getListDistrict(pageDistrict,limitDistrict)
      // }, 256);
    }
  };

  console.log("searchv", searchValue);
  const onChangeDistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListDistrict([]);
      setPageDistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListDistrict(
          form?.country_pic,
          form?.province_pic,
          pageDistrict,
          limitDistrict,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListDistrict([]);
      setFilter(resetFilter);
      setPageDistrict(resetPage);
      getListDistrict(
        form?.country_pic,
        form?.province_pic,
        pageDistrict,
        limitDistrict,
        filter
      );
    }
  };
  const onScrollSubdistrict = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageSubdistrict(pageSubdistrict + 1);
      target.scrollTo(0, target.scrollHeight);
      getListSubDistrict(
        form?.country_pic,
        form?.district_pic,
        pageSubdistrict,
        limitSubdistrict,
        ""
      );
      // setTimeout(() => {
      //   getListSubdistrict(pageSubdistrict,limitSubdistrict)
      // }, 256);
    }
  };

  const onChangeSubdistrict = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListSubDistrict([]);
      setPageSubdistrict(resetPage);
      // this.setState(
      setTimeout(() => {
        getListSubDistrict(
          form?.country_pic,
          form?.district_pic,
          pageSubdistrict,
          limitSubdistrict,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListSubDistrict([]);
      setFilter(resetFilter);
      setPageSubdistrict(resetPage);
      getListSubDistrict(
        form?.country_pic,
        form?.district_pic,
        pageSubdistrict,
        limitSubdistrict,
        filter
      );
    }
  };
  const onScrollUrbanvillage = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      console.log("sini g");
      setPageUrbanvillage(pageUrbanvillage + 1);
      target.scrollTo(0, target.scrollHeight);
      getListUrbanVillage(
        form?.country_pic,
        form?.sub_district_pic,
        pageUrbanvillage,
        limitUrbanvillage,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onScrollPostalCode = (event) => {
    let target = event.target;
    if (
      target.scrollHeight - Math.ceil(target.scrollTop) ===
      target.clientHeight ||
      (target.scrollHeight - Math.ceil(target.scrollTop) ===
        target.clientHeight + 1 &&
        !loading)
    ) {
      setLoading(true);
      setPagePostalCode(pagePostalCode + 1);
      target.scrollTo(0, target.scrollHeight);
      getListPostalCode(
        form?.urban_village_id,
        pagePostalCode,
        limitPostalCode,
        ""
      );
      // setTimeout(() => {
      //   getListUrbanvillage(pageUrbanvillage,limitUrbanvillage)
      // }, 256);
    }
  };

  const onChangeUrbanvillage = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListUrbanVillage([]);
      setPageUrbanvillage(resetPage);
      // this.setState(
      setTimeout(() => {
        getListUrbanVillage(
          form?.country_pic,
          form?.sub_district_pic,
          pageUrbanvillage,
          limitUrbanvillage,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListUrbanVillage([]);
      setFilter(resetFilter);
      setPageUrbanvillage(resetPage);
      getListUrbanVillage(
        form?.country_pic_id,
        form?.sub_district_pic,
        pageUrbanvillage,
        limitUrbanvillage,
        filter
      );
    }
  };

  const onChangePostalCode = (event) => {
    const { value } = event.target;
    const resetPage = 1;
    // clearTimeout(this.inputTimer);
    let filterSearch = value && `${value}`;
    // this.setState({
    //   searchValue: value,
    // });
    setSearchValue(value);
    let filter = [filterSearch];
    filter = filter.filter(
      (item) => item !== undefined && item !== null && item !== ""
    );
    filter = filter.length !== 0 ? filter.join(", ") : undefined;
    const resetFilter = filter;
    if (value.length >= 2) {
      setListPostalCode([]);
      setPagePostalCode(resetPage);
      // this.setState(
      setTimeout(() => {
        getListPostalCode(
          form?.urban_village_pic,
          pagePostalCode,
          limitPostalCode,
          filter
        );
      }, 256);
    } else if (!value) {
      setLoading(true);
      setListPostalCode([]);
      setFilter(resetFilter);
      setPagePostalCode(resetPage);
      getListPostalCode(
        form?.urban_village_pic,
        pagePostalCode,
        limitPostalCode,
        filter
      );
    }
  };


  //   const getListProvince = async (token, page, limit, filter) => {
  //     const res = await UserServices.listProvince(
  //       token,
  //       null,
  //       page,
  //       limit,
  //       filter,
  //       dispatch
  //     );
  //     if (res?.ok && res?.list?.length > 0) {
  //       const { list } = res;
  //       setListProvince(
  //         list.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }))
  //       );
  //     }
  //   };

  const getListProvince = async (id, page, limit, filter, isChange) => {
    const currentProvince = [...listProvince];
    let provinces = await doGets(
      `/province?page=${page}&limit=${limit}&filter=country_id eq ${id}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = provinces?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setListProvince(selectOption(isZero, option, "value"));
      } else {
        setListProvince(selectOption(currentProvince, option, "value"));
      }
      // setProvince(selectOption(currentProvince, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const isZero = []

  //   const getListDistrict = async (token, page, limit, filter) => {
  //     const res = await UserServices.listDistrict(
  //       token,
  //       null,
  //       page,
  //       limit,
  //       filter,
  //       dispatch
  //     );
  //     if (res?.ok && res.list.length > 0) {
  //       const { list } = res;
  //       setListDistrict(
  //         list.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }))
  //       );
  //     }
  //   };

  //   const getListSubDistrict = async (token, page, limit, filter) => {
  //     const res = await UserServices.listSubDistrict(
  //       token,
  //       null,
  //       page,
  //       limit,
  //       filter,
  //       dispatch
  //     );
  //     if (res?.ok && res.list.length > 0) {
  //       const { list } = res;
  //       setListSubDistrict(
  //         list.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }))
  //       );
  //     }
  //   };

  //   const getListUrbanVillage = async (token, page, limit, filter) => {
  //     const res = await UserServices.listUrbanVillage(
  //       token,
  //       null,
  //       page,
  //       limit,
  //       filter,
  //       dispatch
  //     );
  //     if (res?.ok && res.list.length > 0) {
  //       const { list } = res;
  //       setListUrbanVillage(
  //         list.map((item) => ({
  //           value: item.id,
  //           label: item.name,
  //         }))
  //       );
  //     }
  //   };

  const getListDistrict = async (id, idprov, page, limit, filter, isChange) => {

    const currentDistrict = [...listDistrict];
    let districts = await doGets(
      `/district?page=${page}&limit=${limit}&filter=country_id eq ${id}, province_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setListDistrict(selectOption(isZero, option, "value"));
      } else {
        setListDistrict(selectOption(currentDistrict, option, "value"));
      }
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListSubDistrict = async (id, idprov, page, limit, filter, isChange) => {
    const currentSubdistrict = [...listSubDistrict];
    let districts = await doGets(
      `/sub_district?page=${page}&limit=${limit}&filter=country_id eq ${id}, district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setListSubDistrict(selectOption(isZero, option, "value"));
      } else {
        setListSubDistrict(selectOption(currentSubdistrict, option, "value"));
      }
      // setSubdistrict(selectOption(currentSubdistrict, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListUrbanVillage = async (id, idprov, page, limit, filter, isChange) => {
    const currentUrbanvillage = [...listUrbanVillage];
    let districts = await doGets(
      `/urban_village?page=${page}&limit=${limit}&filter=country_id eq ${id}, sub_district_id eq ${idprov}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = districts?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.name,
        };
        option.push(data);
      }
      if (isChange) {
        setListUrbanVillage(selectOption(isZero, option, "value"));
      } else {
        setListUrbanVillage(selectOption(currentUrbanvillage, option, "value"));
      }
      // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const getListPostalCode = async (idUrbanVillage, page, limit, filter, isChange) => {
    const currentPostalCode = [...listPostalCode];
    let postal_code = await doGets(
      `/postal_code?page=${page}&limit=${limit}&filter=urban_village_id eq ${idUrbanVillage}${filter ? `, name lk ${filter}` : ""
      }`,
      token
    );
    let option = [];
    let list = postal_code?.data?.payload?.data;
    if (list !== null && list.length !== undefined) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        let data = {
          id: element.id,
          value: element.code,
        };
        option.push(data);
      }
      if (isChange) {
        setListPostalCode(selectOption(isZero, option, "value"));
      } else {
        setListPostalCode(selectOption(currentPostalCode, option, "value"));
      }
      // setUrbanvillage(selectOption(currentUrbanvillage, option, "value"));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  // const getListCountry = async (page, limit, filter) => {
  //     const currentCountry = [...country];
  //     let countrys = await doGets(
  //       `/country?page=${page}&limit=${limit}${filter && `&filter=name lk ${filter}`
  //       }&${param}`,
  //       token
  //     );

  //     let option = [];
  //     let list = countrys?.data?.payload?.data;

  //     if (list !== null && list.length !== undefined) {
  //       for (let i = 0; i < list.length; i++) {
  //         const element = list[i];
  //         let data = {
  //           id: element.id,
  //           value: element.name,
  //         };
  //         option.push(data);
  //       }
  //       setListCountry(selectOption(currentCountry, option, "value"));
  //       setLoading(false);
  //       // this.setState({
  //       //   listUser: selectOption(currentUser, option, "value"),
  //       //   initiateUser: initiate,
  //       //   loading: false,
  //       // });
  //     } else {
  //       setLoading(false);
  //       // this.setState({ loading: false, lastPage: true });
  //     }
  //   };

  const handleChange = (value, namespace) => {
    onChanged(dispatch, true);
    const isChange=true
    if (namespace === "to_menu") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
        };
      });
    } else if (namespace === "birth_date_pic") {
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: moment(new Date(value)).format("YYYY-MM-DD"),
        };
      });
    } else if (namespace === "title_pic") {
      let eror = validDepot("title_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
        };
      });
    } else if (
      namespace === "length_uom" ||
      namespace === "weight_uom" ||
      namespace === "volume_uom" ||
      namespace === "temperature_uom"
    ) {
      let eror = validDepot(namespace, value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
        };
      });
    } else if (namespace === "country_pic") {
      setListProvince([]);
      setListDistrict([]);
      setListSubDistrict([]);
      setListUrbanVillage([]);
      setListPostalCode([]);
      setSearchValue("")
      setFilter("")
      getListProvince(value,1,10,"",isChange);
      let eror = validDepot("country_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
          island_pic: null,
          province_pic: null,
          district_pic: null,
          sub_district_pic: null,
          urban_village_pic: null,
          postal_code_pic: null,
        };
      });

      setRegionalData({
        country_pic: value,
        province_pic: null,
        district_pic: null,
        sub_district_pic: null,
        urban_village_pic: null,
        postal_code_pic: null,
      });
    } else if (namespace === "province_pic") {
      setListDistrict([]);
      setListSubDistrict([]);
      setListUrbanVillage([]);
      setListPostalCode([]);
      getListDistrict(form.country_pic? form.country_pic : data.country_pic
        , value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDepot("province_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
          district_pic: null,
          sub_district_pic: null,
          urban_village_pic: null,
          postal_code_pic: null,
        };
      });

      setRegionalData((prevsValue) => ({
        ...prevsValue,
        province_pic: value,
        district_pic: null,
        sub_district_pic: null,
        urban_village_pic: null,
        postal_code_pic: null,
      }));
    } else if (namespace === "district_pic") {
      setListSubDistrict([]);
      setListUrbanVillage([]);
      setListPostalCode([]);
      getListSubDistrict(
        form.country_pic ? form.country_pic : data.country_pic
        , value,1,10,"",isChange);
        setSearchValue("")
        setFilter("")
      let eror = validDepot("district_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
          sub_district_pic: null,
          urban_village_pic: null,
          postal_code_pic: null,
        };
      });

      setRegionalData((prevsValue) => ({
        ...prevsValue,
        district_pic: value,
        sub_district_pic: null,
        urban_village_pic: null,
        postal_code_pic: null,
      }));
    } else if (namespace === "sub_district_pic") {
      setListUrbanVillage([]);
      setListPostalCode([]);
      getListUrbanVillage(
        form.country_pic ? form.country_pic : data.country_pic
        , value,1,10,"",isChange);
        setSearchValue("")
        setFilter("")
      let eror = validDepot("sub_district_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
          urban_village_pic: null,
          postal_code_pic: null,
        };
      });

      setRegionalData((prevsValue) => ({
        ...prevsValue,
        sub_district_pic: value,
        urban_village_pic: null,
        postal_code_pic: null,
      }));
    } else if (namespace === "urban_village_pic") {
      setListPostalCode([]);
      getListPostalCode(
        value,1,10,"",isChange);
      setSearchValue("")
      setFilter("")
      let eror = validDepot("urban_village_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
          postal_code_pic: null,
        };
      });

      setRegionalData((prevsValue) => ({
        ...prevsValue,
        urban_village_pic: value,
        postal_code_pic: null,
      }));
    } else if (namespace === "postal_code_pic") {
      let eror = validDepot("postal_code_pic", value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value,
        };
      });

      setRegionalData((prevsValue) => ({
        ...prevsValue,
        postal_code_pic: value,
      }));
    } else if (namespace === "max_range") {
      let eror = validDepot("max_range", value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        return {
          ...prevsValue,
          [namespace]: value.target.value,
        };
      });
    } else {
      let eror = validDepot(namespace, value.target.value, t);
      setError({ ...error, ...eror });
      setForm((prevsValue) => {
        console.log("gender", value.target.value);
        return {
          ...prevsValue,
          [namespace]: value.target.value,
        };
      });
    }
    setAdded(false);
  };

  const handleAdd = (id) => {
    onChanged(dispatch, true);
    if (typeof id === "string") {
      let errors = {};
      let sub = {
        id: id,
        position_pic: form.position_pic ? form.position_pic : "",
        title_pic: form.title_pic ? form.title_pic : 0,
        first_name_pic: form.first_name_pic ? form.first_name_pic : "",
        last_name_pic: form.last_name_pic ? form.last_name_pic : "",
        gender_pic: form.gender_pic ? form.gender_pic : "",
        birth_place_pic: form.birth_place_pic ? form.birth_place_pic : "",
        birth_date_pic: form.birth_date_pic ? form.birth_date_pic : "",
        phone_number_pic: form.phone_number_pic ? form.phone_number_pic : "",
        email_pic: form.email_pic ? form.email_pic : "",
        nik_pic: form.nik_pic ? form.nik_pic : "",
        npwp_pic: form.npwp_pic ? form.npwp_pic : "123456789123456",
        country_pic: form.country_pic ? form.country_pic : "",
        province_pic: form.province_pic ? form.province_pic : "",
        district_pic: form.district_pic ? form.district_pic : "",
        sub_district_pic: form.sub_district_pic ? form.sub_district_pic : "",
        urban_village_pic: form.urban_village_pic ? form.urban_village_pic : "",
        address_pic: form.address_pic ? form.address_pic : "",
        neighborhood_pic: form.neighborhood_pic ? form.neighborhood_pic : "",
        hamlet_pic: form.hamlet_pic ? form.hamlet_pic : "",
        postal_code_pic: form.postal_code_pic ? form.postal_code_pic : "",
      };

      for (const key in sub) {
        const option = validDepot(key, sub[key], t);
        const currentError = option;
        errors = { ...currentError, ...errors };
      }

      setError(errors);
      if (validateSubmit(errors)) {
        if (Object.keys(picList[0]).length === 1) {
          setPicList([sub]);
        } else {
          let tempPicList = picList;
          let index = tempPicList.findIndex((item) => item.id === id);
          tempPicList.splice(index, 1, sub);
          setPicList(tempPicList);
        }

        setAdded(true);
        setIsOpen(false);
        checkHasEmpty();
      }
    } else if (typeof id === "number" || id === undefined) {
      let errors = {};
      let data = picList.filter((item) => item.id_pic === id)[0];
      let sub = {
        id_pic: data?.id_pic,
        position_pic:
          form.position_pic !== undefined
            ? form.position_pic
            : data?.position_pic,
        title_pic:
          form.title_pic !== undefined ? form.title_pic : data?.title_pic,
        first_name_pic:
          form.first_name_pic !== undefined
            ? form.first_name_pic
            : data?.first_name_pic,
        last_name_pic:
          form.last_name_pic !== undefined
            ? form.last_name_pic
            : data?.last_name_pic,
        gender_pic:
          form.gender_pic !== undefined ? form.gender_pic : data?.gender_pic,
        birth_place_pic:
          form.birth_place_pic !== undefined
            ? form.birth_place_pic
            : data?.birth_place_pic,
        birth_date_pic:
          form.birth_date_pic !== undefined
            ? form.birth_date_pic
            : data?.birth_date_pic,
        phone_number_pic:
          form.phone_number_pic !== undefined
            ? form.phone_number_pic
            : data?.phone_number_pic?.replace("+62-", ""),
        email_pic:
          form.email_pic !== undefined ? form.email_pic : data?.email_pic,
        nik_pic: form.nik_pic !== undefined ? form.nik_pic : data?.nik_pic,
        npwp_pic: form.npwp_pic !== undefined ? form.npwp_pic : data?.npwp_pic,
        country_pic:
          form.country_pic !== undefined ? form.country_pic : data?.country_pic,
        province_pic:
          form.province_pic !== undefined
            ? form.province_pic
            : data?.province_pic,
        district_pic:
          form.district_pic !== undefined
            ? form.district_pic
            : data?.district_pic,
        sub_district_pic:
          form.sub_district_pic !== undefined
            ? form.sub_district_pic
            : data?.sub_district_pic,
        urban_village_pic:
          form.urban_village_pic !== undefined
            ? form.urban_village_pic
            : data?.urban_village_pic,
        address_pic:
          form.address_pic !== undefined ? form.address_pic : data?.address_pic,
        neighborhood_pic:
          form.neighborhood_pic !== undefined
            ? form.neighborhood_pic
            : data?.neighborhood_pic,
        hamlet_pic:
          form.hamlet_pic !== undefined ? form.hamlet_pic : data?.hamlet_pic,
        postal_code_pic:
          form.postal_code_pic !== undefined
            ? form.postal_code_pic
            : data?.postal_code_pic,
        updated_at: data?.updated_at,
      };

      for (const key in sub) {
        const option = validDepot(key, sub[key], t);
        const currentError = option;
        errors = { ...currentError, ...errors };
      }

      setError(errors);
      if (validateSubmit(errors)) {
        if (Object.keys(picList[0]).length === 1) {
          setPicList([sub]);
        } else {
          let tempPicList = picList;
          let index = tempPicList.findIndex((item) => item.id_pic === id);
          tempPicList.splice(index, 1, sub);
          setPicList(tempPicList);
        }

        setAdded(true);
        setIsOpen(false);
        checkHasEmpty();
      }
    }
  };

  const handleDelete = () => {
    onChanged(dispatch, true);
    if (from === "edit") {
      const selectedPic = picList.filter(
        (item) => item.id === id || item.id_pic === id
      );
      if (selectedPic[0].id) {
        const updatedList = picList.filter((item) => item.id !== id);
        setPicList(updatedList);
      } else if (selectedPic[0].id_pic) {
        if (_.isEmpty(deletedPicList[0])) {
          const updatedData = selectedPic[0];
          updatedData.is_deleted = true;
          setDeletedPicList([updatedData]);
          setPicList([{}]);
        } else {
          const updatedData = selectedPic[0];
          updatedData.is_deleted = true;

          const tempDeletedPicList = deletedPicList;
          tempDeletedPicList.push(updatedData);

          setDeletedPicList(tempDeletedPicList);
        }

        const updatedList = picList.filter((item) => item.id_pic !== id);
        setPicList(updatedList);
      }
    } else if (from === "add") {
      if (picList.length > 1) {
        let newPicList = picList.filter((item) => item.id !== id);
        setPicList(newPicList);
      } else {
        setPicList([{ id: `id${Math.floor(Math.random() * 100)}` }]);
      }
    }
  };

  const checkValue = (namespace) => {
    switch (namespace) {
      case "province_pic":
        if (
          from === "add" &&
          form.country_pic !== null &&
          form.country_pic !== undefined
        ) {
          return false;
        } else if (
          from === "edit" &&
          regionalData.country_pic !== null &&
          regionalData.country_pic !== undefined
        ) {
          return false;
        } else {
          return true;
        }

      case "district_pic":
        if (
          from === "add" &&
          form.province_pic !== null &&
          form.province_pic !== undefined
        ) {
          return false;
        } else if (
          from === "edit" &&
          regionalData.province_pic !== null &&
          regionalData.province_pic !== undefined
        ) {
          return false;
        } else {
          return true;
        }

      case "sub_district_pic":
        if (
          from === "add" &&
          form.district_pic !== null &&
          form.district_pic !== undefined
        ) {
          return false;
        } else if (
          from === "edit" &&
          regionalData.district_pic !== null &&
          regionalData.district_pic !== undefined
        ) {
          return false;
        } else {
          return true;
        }

      case "urban_village_pic":
        if (
          from === "add" &&
          form.sub_district_pic !== null &&
          form.sub_district_pic !== undefined
        ) {
          return false;
        } else if (
          from === "edit" &&
          regionalData.sub_district_pic !== null &&
          regionalData.sub_district_pic !== undefined
        ) {
          return false;
        } else {
          return true;
        }

      case "postal_code_pic":
        if (
          from === "add" &&
          form.urban_village_pic !== null &&
          form.urban_village_pic !== undefined
        ) {
          return false;
        } else if (
          from === "edit" &&
          regionalData.urban_village_pic !== null &&
          regionalData.urban_village_pic !== undefined
        ) {
          return false;
        } else {
          return true;
        }

      default:
        break;
    }
    return false;
  };

  return form !== undefined ? (
    <div
      className={`z-[20] w-full bg-[#F9F9F9] ${isOpen ? "h-max-[1350px]" : "h-[64px]"
        } mb-[24px] rounded-[4px] shadow-lg py-[16px] px-[20px] overflow-hidden duration-500 transition-all`}
    >
      <div
        className="flex justify-between cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <p className="text-[24px] font-[500]">
          {form?.first_name_pic
            ? form?.first_name_pic + " "
            : "Person in Charge"}
          {form?.last_name_pic ? form?.last_name_pic + " " : ""}-
          {form?.phone_number_pic
            ? " +62-" + form?.phone_number_pic
            : index + 1}
        </p>
        <img
          width={24}
          src={isOpen ? ChevronDown : ChevronUp}
          alt="arrowDown"
        />
      </div>

      <div className="flex mt-[48px] justify-center">
        <div>
          <div className="flex">
            <div className="gap-[40px] mb-[24px]">
              <div className="w-[500px] mb-[24px]">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("DEPOT:PERSONAL_INFORMATION")}
                </h3>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:POSITION") + " (Optional)"}
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  defaultValue={form?.position_pic ? form?.position_pic : ""}
                  value={form?.position_pic ? form?.position_pic : ""}
                  placeholder="Type position"
                  onChange={(value) => handleChange(value, "position_pic")}
                />
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:TITLE") + " (Optional)"}
                </label>
                <Select
                  style={{
                    borderRadius: "6px",
                    fontSize: "20px",
                    marginTop: "8px",
                  }}
                  className="w-[500px]"
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  defaultValue={form?.title_pic ? form?.title_pic : ""}
                  value={form?.title_pic ? form?.title_pic : null}
                  onChange={(value) => handleChange(value, "title_pic")}
                  options={listTitle}
                  placeholder="Select Title"
                />
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("CUSTOMER:FIRST_NAME")}
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "first_name_pic")}
                  status={error?.first_name_pic ? "error" : ""}
                  defaultValue={
                    form?.first_name_pic ? form?.first_name_pic : ""
                  }
                  value={form?.first_name_pic ? form?.first_name_pic : ""}
                  placeholder="Type first name"
                />

                <div className="text-red-100">{error?.first_name_pic}</div>
              </div>

              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("CUSTOMER:LAST_NAME") + " (Optional)"}
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "last_name_pic")}
                  status={error?.last_name_pic ? "error" : ""}
                  defaultValue={form?.last_name_pic ? form?.last_name_pic : ""}
                  value={form?.last_name_pic ? form?.last_name_pic : ""}
                  placeholder="Type last name"
                />

                <div className="text-red-100">{error?.last_name_pic}</div>
              </div>
              {/* GENDER */}
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium mb-[16px]">
                  {t("Gender") + " (Optional)"}
                </label>
                <div className={style.radio}>
                  <Radio.Group
                    onChange={(value) => handleChange(value, "gender_pic")}
                    defaultValue={form?.gender_pic ? form?.gender_pic : ""}
                    value={form?.gender_pic ? form?.gender_pic : ""}
                    className="flex"
                  >
                    <Radio value="M" className="text-[20px]">
                      Male
                    </Radio>
                    <Radio value="F" className="text-[20px]">
                      Female
                    </Radio>
                  </Radio.Group>
                </div>
              </div>
              {/* END GENDER */}
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  Birthplace
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "birth_place_pic")}
                  status={error?.birth_place_pic ? "error" : ""}
                  defaultValue={
                    form?.birth_place_pic ? form?.birth_place_pic : ""
                  }
                  value={form?.birth_place_pic ? form?.birth_place_pic : ""}
                  placeholder="Type birth place"
                />

                <div className="text-red-100">{error?.birth_place_pic}</div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  Birthdate
                </label>
                <DatePicker
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  format={"DD MMMM YYYY"}
                  suffixIcon={<img src={DateIcon} alt="date" />}
                  onChange={(e) => handleChange(e, "birth_date_pic")}
                  className="mt-[8px] h-[47px] w-[500px]"
                  allowClear={true}
                  placeholder="Select birth date"
                  // defaultValue={
                  //   form?.birth_date_pic
                  //     ? dayjs(form?.birth_date_pic, "DD MMMM YYYY")
                  //     : ""
                  // }
                  value={
                    form?.birth_date_pic
                      ? dayjs(form?.birth_date_pic)
                      : ""
                  }
                />

                <div className="text-red-100">{error?.birth_date_pic}</div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:PHONE_NUMBER")}
                </label>
                <Space.Compact>
                  <Input
                    style={{
                      width: "15%",
                      borderRadius: "6px 0 0 6px",
                      fontSize: "20px",
                    }}
                    defaultValue={"+62"}
                    disabled
                  />
                  <Input
                    style={{
                      width: "480px",
                      height: "47px",
                      borderRadius: "0 6px 6px 0",
                      fontSize: "20px",
                    }}
                    onChange={(value) =>
                      handleChange(value, "phone_number_pic")
                    }
                    status={error?.phone_number_pic ? "error" : ""}
                    defaultValue={
                      form?.phone_number_pic ? form?.phone_number_pic : ""
                    }
                    value={form?.phone_number_pic ? form?.phone_number_pic : ""}
                    placeholder="Type phone number"
                  />
                </Space.Compact>

                <div className="text-red-100">{error?.phone_number_pic}</div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("Email")}
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "email_pic")}
                  status={error?.email_pic ? "error" : ""}
                  defaultValue={form?.email_pic ? form?.email_pic : ""}
                  value={form?.email_pic ? form?.email_pic : ""}
                  placeholder="Type email"
                />

                <div className="text-red-100">{error?.email_pic}</div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  ID Card/NIK
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "nik_pic")}
                  status={error?.nik_pic ? "error" : ""}
                  defaultValue={form?.nik_pic ? form?.nik_pic : ""}
                  value={form?.nik_pic ? form?.nik_pic : ""}
                  placeholder="Type NIK"
                />

                <div className="text-red-100">{error?.nik_pic}</div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {"Tax Number (Optional)"}
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "npwp_pic")}
                  status={error?.npwp_pic ? "error" : ""}
                  defaultValue={form?.npwp_pic ? form?.npwp_pic : ""}
                  value={form?.npwp_pic ? form?.npwp_pic : ""}
                  placeholder="Type NPWP"
                />

                <div className="text-red-100">{error?.npwp_pic}</div>
              </div>
            </div>
            <div className="gap-[40px] mb-[24px] ml-36">
              <div className="w-[500px] mb-[24px]">
                <h3 className="font-roboto text-[18px] font-semibold mb-6 mt-2">
                  {t("DEPOT:ADDRESS_INFORMATION")}
                </h3>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:COUNTRY")}
                </label>

                {/* <SelectSearch
                                        from={'ORDER_REQ_ADD'}
                                        onSelect={(value) => handleChange(value, 'country_pic')}
                                        style={style}
                                        status={error?.country_pic ? 'error' : null}
                                        data={listCountry}
                                        placeholder={"Select Country"}
                                        value={form?.country_pic ? form?.country_pic : null}
                                        defaultValue={form?.country_pic ? form?.country_pic : ''}
                                    /> */}

                <Select
                  className="w-[500px]"
                  status={error?.country_pic ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onPopupScroll={(e) => onScrollCountry(e)}
                  loading={loading}
                  value={form.country_pic}
                  onChange={(value) => handleChange(value, "country_pic")}
                  // options={country}
                  placeholder="Select depot country"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeCountry(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? listCountry : [...listCountry, LoadingOption()]}
                </Select>

                <div className="text-red-100 mt-[9px]">
                  {error?.country_pic}
                </div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:PROVINCE")}
                </label>

                {/* <SelectSearch
                  disabled={checkValue("province_pic")}
                  from={"ORDER_REQ_ADD"}
                  value={
                    form?.province_pic !== null ? form?.province_pic : null
                  }
                  onSelect={(value) => handleChange(value, "province_pic")}
                  style={style}
                  status={error?.province_pic ? "error" : null}
                  data={listProvince}
                  placeholder={"Select Province"}
                  defaultValue={form?.province_pic ? form?.province_pic : ""}
                /> */}
                <Select
                  className="w-[500px]"
                  disabled={checkValue("province_pic")}
                  value={form?.province_pic !== null ? form?.province_pic : null
                  }
                  status={error?.province_pic ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  onChange={(value) => handleChange(value, "province_pic")}
                  onPopupScroll={(e) => onScrollProvince(e)}
                  loading={loading}
                  // options={Province}
                  placeholder="Select Province"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeProvince(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? listProvince : [...listProvince, LoadingOption()]}
                </Select>

                <div className="text-red-100 mt-[9px]">
                  {error?.province_pic}
                </div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:DISTRICT")}
                </label>

                {/* <SelectSearch
                  disabled={checkValue("district_pic")}
                  from={"ORDER_REQ_ADD"}
                  value={
                    form?.disctrict_pic !== null ? form?.district_pic : null
                  }
                  onSelect={(value) => handleChange(value, "district_pic")}
                  style={style}
                  status={error?.district_pic ? "error" : null}
                  data={listDistrict}
                  placeholder={"Select District"}
                  defaultValue={
                    form?.district_pic_id ? form?.district_pic_id : ""
                  }
                /> */}

                <Select
                  className="w-[500px]"
                  status={error?.district_pic ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  disabled={checkValue("district_pic")}
                  value={form?.district_pic ? form?.district_pic : ""}
                  size="large"
                  onChange={(value) => handleChange(value, "district_pic")}
                  onPopupScroll={(e) => onScrollDistrict(e)}
                  loading={loading}
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeDistrict(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? listDistrict : [...listDistrict, LoadingOption()]}
                </Select>

                <div className="text-red-100 mt-[9px]">
                  {error?.district_pic}
                </div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:SUB_DISTRICT")}
                </label>

                {/* <SelectSearch
                  disabled={checkValue("sub_district_pic")}
                  from={"ORDER_REQ_ADD"}
                  value={
                    form?.sub_district_pic !== null
                      ? form?.sub_district_pic
                      : null
                  }
                  onSelect={(value) => handleChange(value, "sub_district_pic")}
                  style={style}
                  status={error?.sub_district_pic ? "error" : null}
                  data={listSubDistrict}
                  placeholder={"Select Sub District"}
                  defaultValue={
                    form?.sub_district_pic ? form?.sub_district_pic : ""
                  }
                /> */}

                <Select
                  className="w-[500px]"
                  status={error?.sub_district_pic ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  disabled={checkValue("sub_district_pic")}
                  value={form?.sub_district_pic !== null
                    ? form?.sub_district_pic
                    : null}
                  onChange={(value) =>
                    handleChange(value, "sub_district_pic")
                  }
                  onPopupScroll={(e) => onScrollSubdistrict(e)}
                  loading={loading}
                  // options={Subdistrict}
                  placeholder="Select Subdistrict"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeSubdistrict(value),
                      searchValue
                    )
                  }
                >
                  {!loading ? listSubDistrict : [...listSubDistrict, LoadingOption()]}
                </Select>

                <div className="text-red-100  mt-[9px]">
                  {error?.sub_district_pic}
                </div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:URBAN_VILLAGE")}
                </label>

                {/* <SelectSearch
                  disabled={checkValue("urban_village_pic")}
                  from={"ORDER_REQ_ADD"}
                  value={
                    form?.urban_village_pic !== null
                      ? form?.urban_village_pic
                      : null
                  }
                  onSelect={(value) => handleChange(value, "urban_village_pic")}
                  style={style}
                  status={error?.urban_village_pic ? "error" : null}
                  data={listUrbanVillage}
                  placeholder={"Select Urban Village"}
                  defaultValue={
                    form?.urban_village_pic ? form?.urban_village_pic : ""
                  }
                /> */}
                <Select
                  className="w-[500px]"
                  status={error?.urban_village_pic ? "error" : ""}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  disabled={checkValue("urban_village_pic")}
                  value={form?.urban_village_pic !== null
                    ? form?.urban_village_pic
                    : null}
                  onChange={(value) =>
                    handleChange(value, "urban_village_pic")
                  }
                  onPopupScroll={(e) => onScrollUrbanvillage(e)}
                  loading={loading}
                  // options={Urbanvillage}
                  placeholder="Select depot Urbanvillage"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangeUrbanvillage(value),
                      searchValue
                    )
                  }
                >
                  {!loading
                    ? listUrbanVillage
                    : [...listUrbanVillage, LoadingOption()]}
                </Select>

                <div className="text-red-100 mt-[9px]">
                  {error?.urban_village_pic}
                </div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("DEPOT:ADDRESS") + " (Optional)"}
                </label>
                <Input
                  style={{ borderRadius: "6px", fontSize: "20px" }}
                  className="mt-[8px] h-[47px] w-[500px]"
                  onChange={(value) => handleChange(value, "address_pic")}
                  status={error?.address_pic ? "error" : ""}
                  defaultValue={form?.address_pic ? form?.address_pic : ""}
                  value={form?.address_pic ? form?.address_pic : ""}
                  placeholder="Type address"
                />

                <div className="text-red-100">{error?.address_pic}</div>
              </div>
              <div className="w-[500px] mb-[24px] flex">
                <div>
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:HAMLET") + " (Optional)"}
                  </label>
                  <Input
                    style={{ borderRadius: "6px", fontSize: "20px" }}
                    className="mt-[8px] h-[47px] w-[200px]"
                    onChange={(value) => handleChange(value, "hamlet_pic")}
                    status={error?.hamlet_pic ? "error" : ""}
                    defaultValue={form?.hamlet_pic ? form?.hamlet_pic : ""}
                    value={form?.hamlet_pic ? form?.hamlet_pic : ""}
                    placeholder="Type hamlet"
                  />

                  <div className="text-red-100">{error?.hamlet_pic}</div>
                </div>
                <div>
                  <label className="font-roboto text-[16px] font-medium">
                    {t("CUSTOMER:NEIGHBOURHOOD") + " (Optional)"}
                  </label>
                  <Input
                    style={{ borderRadius: "6px", fontSize: "20px" }}
                    className="mt-[8px] h-[47px] w-[200px]"
                    onChange={(value) =>
                      handleChange(value, "neighborhood_pic")
                    }
                    status={error?.neighborhood_pic ? "error" : ""}
                    defaultValue={
                      form?.neighborhood_pic ? form?.neighborhood_pic : ""
                    }
                    value={form?.neighborhood_pic ? form?.neighborhood_pic : ""}
                    placeholder="Type neighborhood"
                  />

                  <div className="text-red-100">{error?.neighborhood_pic}</div>
                </div>
              </div>
              <div className="w-[500px] mb-[24px]">
                <label className="font-roboto text-[16px] font-medium">
                  {t("CUSTOMER:POSTAL_CODE")}
                </label>

                <Select
                  className="w-[500px]"
                  status={error?.postal_code_pic ? "error" : null}
                  dropdownStyle={{
                    backgroundColor: "white",
                  }}
                  size="large"
                  disabled={checkValue("postal_code_pic")}
                  value={form?.postal_code_pic !== null
                    ? form?.postal_code_pic
                    : null}
                  onChange={(value) =>
                    handleChange(value, "postal_code_pic")
                  }
                  onPopupScroll={(e) => onScrollPostalCode(e)}
                  loading={loading}
                  // options={Urbanvillage}
                  placeholder="Select Postal Code"
                  dropdownRender={(menu) =>
                    dropdownCustom(
                      menu,
                      (value) => onChangePostalCode(value),
                      searchValue
                    )
                  }
                >
                  {!loading
                    ? listPostalCode
                    : [...listPostalCode, LoadingOption()]}
                </Select>

                <div className="text-red-100 mt-[9px]">
                  {error?.postal_code_pic}
                </div>
              </div>
            </div>
          </div>

          <div className="flex gap-[16px] flex-row-reverse">
            <PrimaryButton
              text={"Add"}
              action={() => handleAdd(id)}
              disabled={added}
            />
            <SecondaryButton text={"Delete"} action={() => handleDelete(id)} />
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
}
